import { useState } from 'react';
import { Text } from '@mercator-gcp/grout';
import { ProjectDetail } from '@mercator-gcp/types/backend/Project';
import AIMarker from 'components/elements/AIMarker';
import { FlexColumn } from 'components/layout/FlexColumn/FlexColumn';
import { Panel } from 'components/layout/Panel';
import GenerateDetailsWithAIButton from 'components/widgets/ProjectDetails/GenerateDetailsWithAI/Button';
import DisplayAIResponse from 'components/widgets/ProjectDetails/GenerateDetailsWithAI/DisplayAIResponse';
import RequestDiplayGatorBot from 'components/widgets/ProjectDetails/GenerateDetailsWithAI/RequestDisplayGatorBot';

const generateAIStyle = {
  gap: 'padding_8',
};

type Props = {
  projectSlug?: string;
  documentId?: string;
  existingAiInsights?: ProjectDetail['ai_insights'];
  disableOnDemand?: boolean;
};

const ProjectDetailsWithAISection = ({
  projectSlug,
  documentId,
  existingAiInsights,
  disableOnDemand = false,
}: Props) => {
  const [requestedOnDemandInsight, setRequestedOnDemandInsight] = useState(false);

  const handleRequestAIProjectDetails = () => {
    setRequestedOnDemandInsight(true);
  };

  // If disableOnDemand is true, only show if insights already exist
  if (disableOnDemand && !existingAiInsights) {
    return null;
  }

  if (existingAiInsights) {
    return (
      <Panel
        title="AI Actionable Insights"
        icon={<AIMarker showLabel={false} />}
        titleTag={<Text.SmallLabel>BETA</Text.SmallLabel>}
      >
        <DisplayAIResponse
          existingAiInsights={existingAiInsights}
          projectSlug={projectSlug || documentId}
        />
      </Panel>
    );
  }

  return (
    <Panel
      title="AI Actionable Insights"
      icon={<AIMarker showLabel={false} />}
      titleTag={<Text.SmallLabel>BETA</Text.SmallLabel>}
    >
      {requestedOnDemandInsight ? (
        <RequestDiplayGatorBot projectSlug={projectSlug} documentId={documentId} />
      ) : (
        <FlexColumn sx={generateAIStyle}>
          <Text.Body>
            The AI reviews this project, analyzes the opportunity, and suggests next
            steps.
          </Text.Body>
          <GenerateDetailsWithAIButton
            projectSlug={projectSlug}
            documentId={documentId}
            onClick={handleRequestAIProjectDetails}
          />
        </FlexColumn>
      )}
    </Panel>
  );
};

export default ProjectDetailsWithAISection;
